import script from "./DiagnosticsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticsPanel.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticsPanel.vue?vue&type=style&index=0&id=8868f4ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8868f4ec"]])

export default __exports__